export default __webpack_public_path__ + "static/media/wait-for-connect.efda1f04.png";